<template>
  <PageWrap>
    <HeadSeo :data="data" />
    <HeaderOther :h1="data?.h1" />
    <main>
      <BlockPageText :html="data?.text" />
      <BlockWhyWe />
      <BlockContact />
    </main>
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
const { data } = await useFetch("/api/policy");
</script>
